import { render, staticRenderFns } from "./UpdateBusinessMemberAppointmentLocation.vue?vue&type=template&id=333e4ab6"
import script from "./UpdateBusinessMemberAppointmentLocation.vue?vue&type=script&lang=js"
export * from "./UpdateBusinessMemberAppointmentLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports